import { useState, useCallback } from 'react';
import { OnboardingData, initialOnboardingData } from './onboardingState';

const STORAGE_KEY = 'krewe_onboarding';

function load(): OnboardingData {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return { ...initialOnboardingData, ...JSON.parse(raw) };
  } catch {}
  return { ...initialOnboardingData };
}

function save(data: OnboardingData) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function clearOnboardingData() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function useOnboardingData() {
  const [data, setDataInternal] = useState<OnboardingData>(load);

  const setData = useCallback((updates: Partial<OnboardingData>) => {
    setDataInternal((prev) => {
      const next = { ...prev, ...updates };
      save(next);
      return next;
    });
  }, []);

  return { data, setData };
}
